import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Toasts from "../../../core/common/toast";
import { changePassword } from "../../../core/data/redux/adminAuthSlice";
import { all_routes } from "../../router/all_routes";

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

const schema = Yup.object().shape({
  current_password: Yup.string().required("Current password is required"),
  new_password: Yup.string()
    .required("New password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(
      passwordRegex,
      "Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), undefined], "Passwords must match")
    .required("Confirm password is required"),
});

const ChangePassword = () => {
  const routes = all_routes;
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const employeeAuthState = useSelector(
    (state: any) => state.adminAuthState
  );

  

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: any) => {
    dispatch(changePassword(data));
  };

  useEffect(() => {
    if (
      employeeAuthState.loading === "fulfilled" &&
      employeeAuthState.action === "change-password"
    ) {
      navigation(routes.adminResetPasswordSuccess);
    }
  }, [employeeAuthState.loading]);

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [password, setPassword] = useState("");
  const [passwordResponce, setPasswordResponce] = useState({
    passwordResponceText:
      "Use 8 or more characters with a mix of letters, numbers, and symbols.",
    passwordResponceKey: "",
  });

  const togglePasswordVisibility = (field: "password" | "confirmPassword") => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const onChangePassword = (password: string) => {
    setPassword(password);
    if (password.match(/^$|\s+/)) {
      setPasswordResponce({
        passwordResponceText:
          "Use 8 or more characters with a mix of letters, numbers & symbols",
        passwordResponceKey: "",
      });
    } else if (password.length === 0) {
      setPasswordResponce({
        passwordResponceText: "",
        passwordResponceKey: "",
      });
    } else if (password.length < 8) {
      setPasswordResponce({
        passwordResponceText: "Weak. Must contain at least 8 characters",
        passwordResponceKey: "0",
      });
    } else if (
      password.search(/[a-z]/) < 0 ||
      password.search(/[A-Z]/) < 0 ||
      password.search(/[0-9]/) < 0
    ) {
      setPasswordResponce({
        passwordResponceText:
          "Average. Must contain at least 1 upper case and number",
        passwordResponceKey: "1",
      });
    } else if (password.search(/(?=.*?[#?!@$%^&*-])/) < 0) {
      setPasswordResponce({
        passwordResponceText: "Almost. Must contain a special symbol",
        passwordResponceKey: "2",
      });
    } else {
      setPasswordResponce({
        passwordResponceText: "Awesome! You have a secure password.",
        passwordResponceKey: "3",
      });
    }
  };

  return (
    <div>
      <Toasts
        show={employeeAuthState.loading === "rejected"}
        message={employeeAuthState.error}
        title={"Failed"}
        type={"danger"}
      />
      <div className="page-wrapper">
        <div className="content">
          <div className="card">
            {/* <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-4 mt-3">Change Password</h4>
            </div> */}
            <form
              onSubmit={handleSubmit(onSubmit)}
              style={{ width: "50%", margin: "0 auto", marginTop: 50 }}
            >
              <div className="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div className="">
                  <div className="text-center mb-3">
                    <h2 className="mb-2">Change Password</h2>
                    <p className="mb-0">
                      Your new password must be different from previous used
                      passwords.
                    </p>
                  </div>
                  <div>
                    <div className="input-block mb-3">
                      <div className="mb-3">
                        <label className="form-label">Current Password</label>
                        <div className="pass-group" id="passwordInput">
                          <input
                            type={
                              passwordVisibility.password ? "text" : "password"
                            }
                            className="form-control pass-input"
                            placeholder="Enter your password"
                            {...register("current_password")}
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() => togglePasswordVisibility("password")}
                            style={{ cursor: "pointer" }}
                          ></span>
                        </div>
                      </div>
                      {errors.current_password && (
                        <small className="text-danger align-items-left">
                          {errors.current_password.message}
                        </small>
                      )}
                    </div>

                    <div className="input-block mb-3">
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="pass-group" id="passwordInput">
                          <input
                            type={
                              passwordVisibility.password ? "text" : "password"
                            }
                            className="form-control pass-input"
                            placeholder="Enter your new password"
                            {...register("new_password")}
                            onChange={(e) => onChangePassword(e.target.value)}
                          />
                          <span
                            className={`ti toggle-passwords ${
                              passwordVisibility.password
                                ? "ti-eye"
                                : "ti-eye-off"
                            }`}
                            onClick={() => togglePasswordVisibility("password")}
                            style={{ cursor: "pointer" }}
                          ></span>
                        </div>
                      </div>
                      {errors.new_password && (
                        <small className="text-danger align-items-left">
                          {errors.new_password.message}
                        </small>
                      )}
                      <div
                        className={`password-strength d-flex ${
                          passwordResponce.passwordResponceKey === "0"
                            ? "poor-active"
                            : passwordResponce.passwordResponceKey === "1"
                            ? "avg-active"
                            : passwordResponce.passwordResponceKey === "2"
                            ? "strong-active"
                            : passwordResponce.passwordResponceKey === "3"
                            ? "heavy-active"
                            : ""
                        }`}
                        id="passwordStrength"
                      >
                        <span id="poor" className="active" />
                        <span id="weak" className="active" />
                        <span id="strong" className="active" />
                        <span id="heavy" className="active" />
                      </div>
                    </div>
                    <p className="fs-12">
                      {passwordResponce.passwordResponceText}
                    </p>
                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <div className="pass-group">
                        <input
                          type={
                            passwordVisibility.confirmPassword
                              ? "text"
                              : "password"
                          }
                          className="pass-input form-control"
                          {...register("confirm_password")}
                        />
                        <span
                          className={`ti toggle-passwords ${
                            passwordVisibility.confirmPassword
                              ? "ti-eye"
                              : "ti-eye-off"
                          }`}
                          onClick={() =>
                            togglePasswordVisibility("confirmPassword")
                          }
                        ></span>
                      </div>
                      {errors.confirm_password && (
                        <small className="text-danger align-items-left">
                          {errors.confirm_password.message}
                        </small>
                      )}
                    </div>
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={employeeAuthState.loading === "pending"}
                      >
                        {employeeAuthState.loading === "pending"
                          ? "Updating Password..."
                          : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-5 pb-4 text-center">
                  <p className="mb-0 text-gray-9">Copyright © 2024 - Smarthr</p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
